<div class="modal-header">
  <div class="modal-header-title">Bounded Summary Forms</div>
</div>
<div class="modal-body">
  <div class="alert alert-info">
    <p class="text-center">This form is used as a data source in the following forms:</p>
  </div>

  <table class="table table-striped user-list">
    <tbody>
      <tr>
        <th>Form</th>
        <th>Date</th>
        <th>Phase</th>
        <th>Status</th>
      </tr>
      @for (form of summaryFormInstances; track form) {
      <tr class="clickable" (click)="openFormInstance(form.Id)">
        <td>
          {{ form.InstanceNumber === null ? form.FormName : form.FormName + ' #' + form.InstanceNumber }}
        </td>
        <td>
          {{ form.Date | agencyDate }}
        </td>
        <td>
          {{ form.PhaseName }}
        </td>
        <td>
          {{ form.Status }}
        </td>
      </tr>
      }
    </tbody>
  </table>
  <div class="alert alert-info">
    <p class="text-center">
      By {{ actionProcess }} this form we will automatically reject the form(s) above since the information may change.
      Are you sure you wish to {{ actionText }} this form?
    </p>
  </div>
</div>
<div class="modal-footer">
  <div class="buttons-box">
    <button (click)="close()" type="button" class="fto-legacy-btn btn btn-default">No, Cancel</button>
    <button type="button" class="fto-legacy-btn btn btn-primary" (click)="onConfirm()">{{ actionButtonText }}</button>
  </div>
</div>
